module.exports = __webpack_public_path__ + "img/CATEGORY ICON-15.27da12bc.png";